module.exports = __webpack_public_path__ + "assets/img/menu-chirp-white.20999a8b.svg";